import { render, staticRenderFns } from "./MedicalCertificatesTable.vue?vue&type=template&id=2b861a79"
import script from "./MedicalCertificatesTable.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificatesTable.vue?vue&type=script&lang=ts"
import style0 from "./MedicalCertificatesTable.vue?vue&type=style&index=0&id=2b861a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports